import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ChannelArrowUpContainer = styled.div<React.CSSProperties>`
  cursor: pointer;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: ${30 * Screen.widthRatio}px;
  width: ${46 * Screen.widthRatio}px;
`;

export default ChannelArrowUpContainer;
